import * as HttpService from 'services/http.service';
import { LEAD_CAPTURE } from 'services/url.service';

export const postLeadCaptureFormData = (data) =>
  HttpService.postWithoutAuth(LEAD_CAPTURE, data);

export const WORKING_HOURS = [
  'Sun to Wed (9:00 AM to 12:00 PM)',
  'Sun to Wed (2:00 PM to 6:00 PM)',
  'Thurs/Sat (10:00 AM to 3:00 PM)',
  'Fri (4:00 PM to 6:00 PM)'
];

export const COMMUNICATION_MODE = [
  'Online Video conferencing - Zoom/Google Meet/Other',
  'Over the phone',
  'Personal Meeting',
  'Email'
];

export const VENUE_TYPES = [
  'Help me with the venue',
  'Indoor halls - Ballroom/Banquet halls',
  'Outdoor venue - Villa/Garden/Resorts/Open-air',
  'Others'
];

export const helpOptions = [
  {
    id: 0,
    slug: 'home',
    offerings: [
      { name: 'Furniture', examples: '' },
      { name: 'Audio Visuals', examples: '' },
      { name: 'Decorations', examples: '' },
      { name: 'Venue', examples: '' },
      { name: 'Food & beverage', examples: '' },
      { name: 'Tents & marquees', examples: '' },
      { name: 'DJ and entertainment services', examples: '' },
      {
        name: 'Security support',
        examples: '(Police barriers ,Heras Fencing etc.)'
      },
      {
        name: 'Other Support',
        examples: '(Generators, lighting towers etc.)'
      }
    ],
    rules: [],
    leadType: 4
  },
  {
    id: 3,
    slug: 'celebrations',
    offerings: [
      { name: 'Furniture', examples: '' },
      { name: 'Audio Visuals', examples: '' },
      { name: 'Decorations', examples: '' },
      { name: 'Venue', examples: '' },
      { name: 'Food & beverage', examples: '' },
      { name: 'Tents & marquees', examples: '' },
      { name: 'DJ and entertainment services', examples: '' },
      {
        name: 'Security support',
        examples: '(Police barriers ,Heras Fencing etc.)'
      },
      {
        name: 'Other Support',
        examples: '(Generators, lighting towers etc.)'
      }
    ],
    rules: [],
    leadType: 3
  }
];

export const leadEventOptions = [
  {
    slug: 'celebrations',
    options: [
      {
        id: 'd3a0706f-0df0-4731-ab42-227661c78f37',
        name: 'Cultural & Religious Events'
      },
      {
        id: '5a8b89e7-abb9-440f-b784-f73f8c5f435d',
        name: 'Personal Milestones'
      },
      {
        id: '70a11543-9593-43c7-b75a-919d8185680b',
        name: 'National Events'
      },
      {
        id: '45237596-72e3-4204-8399-0289380b96e4',
        name: 'Large Public Events'
      },
      {
        id: 'b88c6870-25f6-4016-aa3e-25a590f01b1b',
        name: 'School & College Events'
      }
    ]
  }
];
